import RoomClient from "components/containers/utils/mediaSoup/RoomClient";
import {
  ShareScreenControl,
  BadgeControl,
  ReactionControl,
  RaiseHandControl,
  MenuControl,
  SoundSettings,
  SpeakerControl,
} from ".";
import Slider from "./Slider";
// import Image from "next/image";
// import Icon from "@/assets/icons";
import { AudioControl, VideoControl } from ".";
import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { HiSparkles } from "react-icons/hi2";
import { toggleBackgroundEffect } from "store/reducers/livestreamSettings";

interface ConsoleControlPanelProps {
  roomClient: RoomClient | null;
}

const ConsoleControlPanel = ({ roomClient }: ConsoleControlPanelProps) => {
  const settings = useSelector((state: RootState) => state.live.settings);
  const dispatch = useDispatch();

  // Handle video stream from producers
  const producers = useSelector((state: any) => state.live.settings?.producers);
  return (
    <>

      <div className="flex rounded-full h-full w-full text-white pl-2 pr-2 justify-between items-center space-x-4">
        <div className="flex gap-4 mobile:gap-2 tablet:gap-2 laptop:gap-3 items-center">

          {/* Final components of console control panel */}
          {/* Show ShareScreenControl only on laptop and above */}
          <div className="hidden laptop:block tablet:block largescreen:block desktop:block">
            <ShareScreenControl roomClient={roomClient} />
          </div>
          <div className="hidden laptop:block tablet:block largescreen:block desktop:block relative">
            <BadgeControl showButton={true} />
            {settings.hasNewBadge && (
              <span className="absolute top-0 right-0 w-3 h-3 bg-red-500 rounded-full"></span>
            )}
          </div>
          <ReactionControl />
          <RaiseHandControl />
          {/* Conditional rendering of speaker icon based on audio state */}
          <div className="">
            <SpeakerControl audioSourceUrl="string" />
          </div>
          <MenuControl />
          <div className="mobile:block hidden mobile:inline-flex mobile:gap-2">
            <VideoControl roomClient={roomClient} />
            {settings.video ? (
              <div className="bg-app-yellow cursor-pointer hover:scale-110 ease-in-out delay-75 w-14 h-14 rounded-2xl flex justify-center items-center false
                      mobile:w-12vw mobile:h-12vh mobile:bg-[rgb(95,72,138)] text-black text-[30px] mobile:rounded-full mobile:text-white mobile:text-[14px] mobile:bg-[rgb(95,72,138)] 
                      mobile:shadow-[inset_-8px_-8px_16px_rgb(152,122,209),inset_8px_8px_8px_rgba(2,2,2,0.61)] mobile:w-10 mobile:h-10">
                <HiSparkles
                  onClick={() => dispatch(toggleBackgroundEffect())}
                />
              </div>
            ) : null}
            <div className="mobile:w-12vw mobile:h-12vh">
              <AudioControl roomClient={roomClient} />
            </div>
            {settings?.audio && <SoundSettings audioSourceUrl="string" />}
          </div>
          {/* Slider - only visible on mobile, styled to look consistent and responsive */}
          <Slider roomClient={roomClient} />
        </div>
      </div>
    </>
  );
};

export default ConsoleControlPanel;